import { Contact as ContactComponent } from '../components';

const Contact = () => {
   return <ContactComponent />;
};
export default Contact;
